import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { SavedSearch } from '../classes/saved-search';
import { UserService } from '../services/user.service';
import {  map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable()
export class ListingQueryParamResolver implements Resolve<SavedSearch | Boolean> {
  constructor(
    private userService: UserService
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<SavedSearch | Boolean> {
    if (route.queryParamMap.keys.includes('savedSearchKey')) {
      const savedSearchReq =  (this.userService.getSavedSearch(encodeURIComponent(route.queryParamMap.get('savedSearchKey'))));
      if (!savedSearchReq) {
        return of(null);
      } else {
        return savedSearchReq.pipe(map((savedSearch: SavedSearch) => {
          if (!savedSearch) {
            return false;
          }
          return savedSearch;
        }));
      }

    } else {
      return of(null);
    }
  }
}
